import { render } from "./QuickMenuView.vue?vue&type=template&id=bcbf5068&scoped=true"
import script from "./QuickMenuView.vue?vue&type=script&lang=js"
export * from "./QuickMenuView.vue?vue&type=script&lang=js"

import "./QuickMenuView.vue?vue&type=style&index=0&id=bcbf5068&scoped=true&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcbf5068"]])

export default __exports__